// extracted by mini-css-extract-plugin
export default {"search":"TextLayout_search__qW0er"};